// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
const { pluralize } = require('shared/string-utils')
// Common client-v2 imports
const { ArticleAddCircleButton } = require('client-v2/common/components/buttons')
const { registerEventHandlerShim } = require('client-v2/common/components/utils')
const {
  articleProfileHref,
  articleDomainSearchHref
} = require('client-v2/common/models/article/actions')
const PageContextRecord = require('client-v2/common/models/page-context/record')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('ArticleProfileRelatedItem')

const Collections = pluralize('Collection')

const callbackKeys = [
  'onAddClick',
  'onCollectionsClick',
  'onContentClick',
  'onDomainClick',
  'onMoreActionsClick',
  'onShareClick'
]

class ArticleProfileRelatedItem extends React.PureComponent {
  constructor(props) {
    super(props)

    callbackKeys.forEach(key => registerEventHandlerShim(this, key))
  }

  // Linkage methods

  articleProfileHref() {
    return articleProfileHref(this.props.article)
  }

  // Render methods

  renderActions() {
    return (
      tag('div', {
        className: bem.element('actions')
      },
        tag('button', {
          className: bem.element('action-button', 'more'),
          title: 'Show more actions for this article',
          onClick: this.onMoreActionsClick
        }),
        tag('button', {
          className: bem.element('action-button', 'share'),
          title: 'Share this article with a friend',
          onClick: this.onShareClick
        }),
        tag(ArticleAddCircleButton, {
          className: bem.element('action-button', 'add'),
          checked: this.props.article.hasMix,
          title: 'Add this article to your collections',
          onClick: this.onAddClick
        })
      )
    )
  }

  renderCollections() {
    const { article: { count } } = this.props
    const label = `In ${count} ${Collections(count)}`
    return (
      tag('a', {
        className: bem.element('collections'),
        href: this.articleProfileHref(),
        title: label,
        onClick: this.onCollectionsClick
      },
        label
      )
    )
  }

  renderDescription() {
    const { article: { description, url } } = this.props
    if (!description) {
      return null
    }
    return (
      tag('a', {
        className: bem.element('description'),
        href: url,
        target: '_blank',
        title: description,
        onClick: this.onContentClick,
        rel: 'nofollow'
      },
        description
      )
    )
  }

  renderDomain() {
    const { article } = this.props
    return (
      tag('a', {
        className: bem.element('domain'),
        href: articleDomainSearchHref(article),
        title: article.hostname,
        onClick: this.onDomainClick
      },
        article.hostname
      )
    )
  }

  renderTitle() {
    const { article: { title, url } } = this.props
    return (
      tag('a', {
        className: bem.element('title'),
        href: url,
        target: '_blank',
        title,
        onClick: this.onContentClick,
        rel: 'nofollow'
      },
        title
      )
    )
  }

  render() {
    return (
      tag('article', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        tag('div', {
          className: bem.element('content')
        },
          this.renderDomain(),
          this.renderTitle(),
          this.renderDescription()
        ),
        tag('div', {
          className: bem.element('footer')
        },
          this.renderCollections(),
          this.renderActions()
        )
      )
    )
  }
}

ArticleProfileRelatedItem.propTypes = {
  // Values
  article: PropTypes.object.isRequired,
  className: PropTypes.string,
  pageContext: PropTypes.shape(PageContextRecord.propTypes)
}

// Callback propTypes
callbackKeys.forEach(key => {
  ArticleProfileRelatedItem.propTypes[key] = PropTypes.func.isRequired
})

module.exports = ArticleProfileRelatedItem
